module.exports = __webpack_public_path__ + "static/BimViewer-839f113a416c91bb24e28f15c65f7f78.png";